import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { DevelopmentModel, GuidSelectModel, ICPLDevelopmentsClient } from "./api/cplapi/CPLAPI";

export interface IDevelopmentsService {
  getDevelopments(): Promise<DevelopmentModel[]>;
  getSelectModels(isServiceChargeOnly?: boolean): Promise<GuidSelectModel[]>;
}

@injectable()
export class DevelopmentsService implements IDevelopmentsService {
  @inject(SERVICE_TYPES.CPLDevelopmentsClient) cplDevelopmentsClient!: ICPLDevelopmentsClient;

  async getDevelopments(): Promise<DevelopmentModel[]> {
    return this.cplDevelopmentsClient.get();
  }

  async getSelectModels(isServiceChargeOnly?: boolean): Promise<GuidSelectModel[]> {
    return this.cplDevelopmentsClient.getSelectModels(isServiceChargeOnly);
  }
}
